import { Component, ElementRef, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import {Config} from '../config';
import {NgStyle} from '@angular/common';
import {Jsonp, Http, Headers, URLSearchParams, Response, RequestOptions } from '@angular/http';
import Moveable = require("dojo/dnd/Moveable");
import dom = require("dojo/dom");
import move = require("dojo/dnd/move");
import {EventsService} from '../EventsService';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'obliquePhoto-component',
    template: require('./obliquePhoto.component.html'),
    styles: [require('./obliquePhoto.component.css')]
})

export class ObliquePhotoComponent implements OnInit {
    appSettings: Object = null;
    iFrameSource:string = "";
    @ViewChild('pictometry_ipa') pictometry_ipa: ElementRef;
    ipa:any = null;
    coordinates:any = null;
    locationSubscription:Subscription;
    showWindow:boolean = true;

    constructor(private elRef: ElementRef, private http: Http, private _eventsService:EventsService) { 
    }

    ngOnInit() {
        if(this.appSettings == null){
            this.appSettings = Config.config[0];
        }

        //var dndMover:any = new move.constrainedMoveable(dom.byId("pictometry_ipa_div"));
        
        /**In case if floating and movable are enabled**/
        // var dnd:dojo.dnd.Moveable = new Moveable(dom.byId("pictometry_ipa_div"));
        // define(["dojox/layout/ResizeHandle"], function(resizeHandle){
        //     var handle = document.createElement('div');
        //     dom.byId("pictometry_ipa_div").appendChild(handle);
        //     var resizer = new resizeHandle({
        //         targetId: "pictometry_ipa_div",
        //         activeResize: false
        //     },handle);
        //     resizer.startup();
        // });
        
    
        this.locationSubscription = this._eventsService.ipaSetLocation$.subscribe(coordinates => {
            this.coordinates = coordinates;
            if(this.ipa){
                this.ipa.setPreferences({
                    enableSynchronization: false
                });
            }
            this.setLocation();
        });

        if (typeof window["PictometryHost"] === 'undefined'){
            this.loadPictometryScript();
        }else{
            this.loadPictometryIPA();
        }
    }

    loadPictometryScript(){
        var newScript:HTMLScriptElement = document.createElement('script');
        newScript.setAttribute('type', 'text/javascript');
        newScript.setAttribute('src', this.appSettings["ObliquePhotos"]["polScript"]);

        newScript.onload = this.loadPictometryIPA.bind(this);
        // if (newScript.addEventListener) {
        //     newScript.addEventListener('load', this.loadPictometryIPA, false);
        // }
        document.getElementsByTagName('head')[0].appendChild(newScript);
    }

    loadPictometryIPA(){
        let headers = new Headers({ 'Content-Type': 'application/xml' });
        let options = new RequestOptions({ headers: headers });
        this.http.get(this.appSettings["ObliquePhotos"]["polService"]).toPromise().then(response => {
                console.log(response);
                if (DOMParser) {
                    var parser = new DOMParser();
                    var xmlDoc:any = parser.parseFromString(response["_body"], "text/xml");
                }
                else // Internet Explorer
                {
                    xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
                    xmlDoc.async = false;
                    xmlDoc.loadXML(response["_body"]);
                }
                console.log(xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue);
                var ifrSource = xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue + "&app_id=" + 'pictometry_ipa';
                
                this.pictometry_ipa.nativeElement.setAttribute('src', ifrSource);

                if(!this.ipa){
                    this.ipa = new window["PictometryHost"]('pictometry_ipa', this.appSettings["ObliquePhotos"]["polWindow"]);
                    this.ipa.ready = this.ipaReady.bind(this);
                    this.ipa.error = this.ipaError.bind(this);
                }
            }).catch(err => {
                console.log(err);
            });
    }

    ipaReady(){
        this.ipa.showDashboard({dualPane:false});
        this.ipa.showDashboard({
            dualPane: false
        });
        this.ipa.setPreferences({
            enableSynchronization: true
        });
        this.ipa.addListener('synchronize', this.ipaSynchronize.bind(this));
        this.ipa.addListener('onchangeview', this.changeView.bind(this));
        this.setLocation();
        // this.ipa.setLocation({
        //     y: 39.768883,       // Latitude
        //     x: -86.158220,      // Longitude
        //     zoom: 17            // Optional Zoom level
        // })
    }

    ipaError(error:any){
        console.log(error);
    }

    ipaSynchronize(view:any){
        this._eventsService.ipaSyncLocation(view);
    }

    changeView(view:any){
        console.log("view change");
        if(this.ipa){
            this.ipa.setPreferences({
                enableSynchronization: true
            });
        }
    }

    setLocation(){
        if(this.coordinates && this.ipa){
            this.showWindow = true;
            this.ipa.setLocation(this.coordinates);
        }
    }

    // destroy 
    ngOnDestroy() {
        // if(this.ipa){
        //     (this.ipa as any).destroy()
        // }
        // if(this.coordinates){
        //     (this.coordinates as any).destroy()
        // }
        if(this.ipa){
            this.ipa.ready = null;
            this.ipa.removeListener('synchronize', this.ipaSynchronize.bind(this));
            this.ipa.removeListener('onchangeview', this.changeView.bind(this));
        }
        this.ipa = null;
        this.coordinates = null;
        this.locationSubscription.unsubscribe();
    }

    closePanel(){
        this._eventsService.disableObliqueImage();
    }
}


// WEBPACK FOOTER //
// ./app/tools/obliquePhoto.component.ts